import { useState, useEffect } from "react";
import { setFlashMessage } from "../../helpers"
import { API_ROUTES } from "../../constants/apiRoutes"
import apiClient from "../../services/api/apiClient"
import loaderGif from '../../resources/img/loader3.gif'
import HousePilotModalMetrics from "./pilot/Modal_Metrics";

class EcoflowManager {
    constructor(setLiveData, setIsLoading) {
        this.setLiveData = setLiveData;
        this.setIsLoading = setIsLoading;
    }

    loadLiveData() {
        this.setIsLoading(true);
        apiClient.get(API_ROUTES.ECOFLOW_GET_DATA)
            .then((data) => {
                if (data.data) {
                    this.setLiveData(data.data);
                }
                this.setIsLoading(false);
            })
            .catch((error) => {
                setFlashMessage('error', 'Erreur lors de la récupération des données EcoFlow');
                console.error(error);
                this.setIsLoading(false);
            });
    }
}

export default function EcoflowDisplay() {
    const [liveData, setLiveData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showModalMetrics, setShowModalMetrics] = useState(false);

    const manager = new EcoflowManager(setLiveData, setIsLoading);

    useEffect(() => {
        manager.loadLiveData();
    }, []);

    const formatValue = (value, unit = '') => {
        if (value === null || value === undefined) return 'N/A';
        if (typeof value === 'number') {
            return value.toLocaleString('fr-FR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + ' ' + unit;
        }
        return value + ' ' + unit;
    };

    return (<>

        <div className="row mx-0">
            {isLoading ? (
                <div className="text-center">
                    <img src={loaderGif} style={{ width: "50px" }} />
                </div>
            ) : liveData ? (

                <div
                    className="deviceBox col-12"
                    style={{ background: '#13617e' }}
                >
                    <i
                        className="fa fa-info-circle float-left cursor-pointer"
                        data-dname="ECOFLOW_LIVE"
                        data-toggle="modal"
                        data-target="#deviceMetrics"
                        onClick={(e) => {
                            e.stopPropagation()
                            setShowModalMetrics(true)
                        }}
                    ></i>
                    <h6>EcoFlow</h6>
                    ⚡ <strong>{formatValue(liveData.consumption?.outputWatts, 'W')}</strong> 
                    &nbsp;&nbsp;| ☀️ <strong>{formatValue(liveData.solar?.outputWatts, 'W')}</strong> 
                    &nbsp;&nbsp;| 🔋 <strong> {formatValue(liveData.battery?.soc, '%')} - {formatValue(liveData.battery?.maxCellTemp, '°C')}</strong> 

                </div>

            ) : (
                <div className="alert alert-warning">Aucune donnée disponible</div>
            )}
        </div>

        <HousePilotModalMetrics
            deviceName="ECOFLOW"
            deviceLabel="EcoFlow"
            showModal={showModalMetrics}
            hiddenFields={['Bat Temp']}
            onModalClose={() => setShowModalMetrics(false)}
        />
    </>)
}
